var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBriefcase(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 14.5,
    viewBox: "0 0 17 14.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_6",
    "data-name": "Union 6",
    d: "M4112,14a2,2,0,0,1-2-2V5.6a23.98,23.98,0,0,0,6.01,1.262A.851.851,0,0,0,4116,7V8a1,1,0,0,0,1,1h3a1,1,0,0,0,1-1V7c0-.021,0-.04,0-.06a26.74,26.74,0,0,0,6-1V12a2,2,0,0,1-2,2Zm-2-9.7V4a2,2,0,0,1,2-2h3V1.5a2,2,0,0,1,2-2h3a2,2,0,0,1,2,2V2h3a2,2,0,0,1,2,2v.743A23.419,23.419,0,0,1,4119,6,21.077,21.077,0,0,1,4110,4.3ZM4120.8,2V1.6a1,1,0,0,0-1-1h-2.6a1,1,0,0,0-1,1V2Z",
    transform: "translate(-4110 0.5)",
    fill: "#515151"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefcase);
export default __webpack_public_path__ + "static/media/briefcase.5507a13460d33793daedff2e51283f83.svg";
export { ForwardRef as ReactComponent };